;
;
const EaseOutQuad = 'cubic-bezier(0.25, 1, 0.5, 1)';
const DefaultObserverOptions = { threshold: .6 };
const Keyfames = `
	@keyframes SoSWipeUp {
		0% {
			clip-path: polygon(0 100%, 100% 100%, 100% 100%, 0 100%);
		}
		100% {
			clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
		}
	}
	@keyframes SoSWipeDown {
		0% {
			clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);
		}
		100% {
			clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
		}
	}
`;
let styleInjected = false;
export const emptyTransition = {
    start: {},
    end: {},
    stagger: 0,
    delay: 0,
    observerOptions: Object.assign({}, DefaultObserverOptions)
};
export const fadeSlideUp = {
    start: {
        'opacity': '0',
        'transform': 'translate(0, 100px)'
    },
    end: {
        'opacity': '1',
        'transform': 'translate(0, 0)',
        'transition': `opacity 1.5s ${EaseOutQuad}, transform 1.5s ${EaseOutQuad}`
    },
    stagger: 130,
    delay: 0,
    observerOptions: Object.assign({}, DefaultObserverOptions)
};
export const fadeSlideDown = {
    start: {
        'opacity': '0',
        'transform': 'translate(0, -100px)'
    },
    end: {
        'opacity': '1',
        'transform': 'translate(0, 0)',
        'transition': `opacity 1.5s ${EaseOutQuad}, transform 1.5s ${EaseOutQuad}`
    },
    stagger: 130,
    delay: 0,
    observerOptions: Object.assign({}, DefaultObserverOptions)
};
export const wipeUp = {
    start: {
        'opacity': '0'
    },
    end: {
        'animation': `SoSWipeUp 1.5s ${EaseOutQuad}`,
        'opacity': '1',
    },
    stagger: 200,
    delay: 0,
    observerOptions: Object.assign({}, DefaultObserverOptions)
};
export const wipeDown = {
    start: {
        'opacity': '0'
    },
    end: {
        'animation': `SoSWipeDown 1.5s ${EaseOutQuad}`,
        'opacity': '1',
    },
    stagger: 200,
    delay: 0,
    observerOptions: Object.assign({}, DefaultObserverOptions)
};
export const makeTransition = (obj) => {
    return Object.assign(Object.assign({}, emptyTransition), obj);
};
const injectStyle = () => {
    document.head.innerHTML += `<style id="show-on-scroll-style">${Keyfames}</style>`;
    styleInjected = true;
};
const isValidTarget = (target) => {
    return target instanceof HTMLElement
        || target instanceof NodeList
        || typeof target === 'string';
};
const styleElement = (element, style) => {
    for (const property in style) {
        element.style.setProperty(property, style[property]);
    }
};
const showOnScroll = (target, transition = Object.assign({}, fadeSlideUp), callback) => {
    var _a;
    let targets = [];
    if (!isValidTarget(target)) {
        throw new Error('Invalid target for scrolling to');
    }
    if (!styleInjected)
        injectStyle();
    if (target instanceof HTMLElement) {
        targets.push(target);
    }
    if (target instanceof NodeList) {
        target.forEach(element => targets.push(element));
    }
    if (typeof target === 'string') {
        (_a = document.querySelectorAll(target)) === null || _a === void 0 ? void 0 : _a.forEach(element => targets.push(element));
    }
    // apply transition start styles
    targets.forEach(target => styleElement(target, transition.start));
    const observerCallback = (entries, observer) => {
        const entriesToShow = entries.filter(entry => entry.isIntersecting);
        entriesToShow.forEach((entry, index) => {
            const target = entry.target;
            observer.unobserve(target);
            const transitionDelay = (transition.stagger * index) + transition.delay;
            // apply transition end styles
            styleElement(target, Object.assign(Object.assign({}, transition.end), { 'transition-delay': `${transitionDelay}ms`, 'animation-delay': `${transitionDelay}ms` }));
            if (typeof callback === 'function')
                callback(target);
        });
    };
    const observer = new IntersectionObserver(observerCallback, transition.observerOptions);
    targets.forEach(target => observer.observe(target));
    return {
        destroy: () => {
            targets.forEach(target => {
                target.style.cssText = '';
            });
            observer.disconnect();
        }
    };
};
export default showOnScroll;
